/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
// import { IAnalytics } from "@/interfaces/Analytics.interface";
import { useQuery } from "@tanstack/react-query";
import { getAnalytics } from "./queryFunctions";
import { IAnalyticsAPIParams } from "@/interfaces/Analytics.interface";

export const useGetAnalyticsWithParams = (params: IAnalyticsAPIParams) => {
  // If we have the query params for the analytics then enable the query
  const isEnabled = !!(
    (params.queryParams?.qna_history_start_date && params.queryParams?.qna_history_end_date) ||
    (params.queryParams?.total_hits_start_date && params.queryParams?.total_hits_end_date)
  );
  return useQuery({
    queryKey: ["analytics", params.projectId, params.queryParams?.qna_history_start_date, params.queryParams?.qna_history_end_date, params.queryParams?.total_hits_start_date, params.queryParams?.total_hits_end_date],
    queryFn: () => getAnalytics({ ...params }),
    enabled: isEnabled,
  });
};
